import React, { useState } from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { ClearSelectionsButton } from '~/components/shared/Buttons'
import {
  FancyCheckBox,
  FancyCheckBoxComponent,
} from '../../shared/FancyCheckBox'

const FindingPurposePageOne = () => {
  const {
    formattedExerciseName,
    trackContent,
    updateResponse,
    exerciseIndex,
    getResponse,
  } = useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageOneTranslations = t('pages.0')
  const phrases = pageOneTranslations.phrases
  const [selectedPhrases, setSelectedPhrases] = useState(
    trackContent[0]?.selected_phrases || [],
  )

  const maxSelections = 5

  const handleCheck = (phrase) => {
    const currentResponse = getResponse(exerciseIndex, 'selected_phrases') || []
    const updatedResponse = selectedPhrases.includes(phrase)
      ? currentResponse.filter((existingItem) => existingItem !== phrase)
      : [...currentResponse, phrase]

    updateResponse(exerciseIndex, 'selected_phrases', updatedResponse)
    setSelectedPhrases(updatedResponse)
  }

  const clearSelectedValues = () => {
    setSelectedPhrases([])
    updateResponse(exerciseIndex, 'selected_phrases', [])
  }

  return (
    <div>
      <p>{pageOneTranslations.list_of_phrases}</p>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {phrases.map((phrase, index) => {
          const isSelected = selectedPhrases.includes(phrase)
          const isDisabled =
            !isSelected && selectedPhrases.length >= maxSelections
          return (
            <FancyCheckBoxComponent
              key={index}
              variant={
                isDisabled ? 'disabled' : isSelected ? 'selected' : 'unselected'
              }
              label={phrase}
            >
              <FancyCheckBox
                checked={isSelected}
                onCheckedChange={() => handleCheck(phrase)}
                disabled={isDisabled}
              />
            </FancyCheckBoxComponent>
          )
        })}
      </div>
      <div className="flex justify-end">
        <ClearSelectionsButton onClick={clearSelectedValues}>
          {pageOneTranslations.clear_selections}
        </ClearSelectionsButton>
      </div>
    </div>
  )
}

export default FindingPurposePageOne
